import { ESourceControl } from '@xmcloud/types';

const { ADO, GitHub } = ESourceControl;

export const isConnectionFromAnotherOrg = (errorMsg: string): boolean => {
	if (!errorMsg?.trim()) return false;
	const lower = errorMsg.toLowerCase();
	// Matched backend phrases (case-insensitive):
	//   "another organization" — integration belongs to a different org
	//   "only the creator"    — caller lacks permission because they didn't create it
	return (
		lower.includes('another organization') ||
		lower.includes('only the creator')
	);
};

/** ADO repo path is org/project/repo (3 segments) */
export const isADORepositoryFormat = (
	repository: string | undefined,
): boolean => !!repository?.trim() && repository.split('/').length === 3;

/** Derive provider from repository path: 3 segments = ADO */
export const getProviderFromRepository = (
	repository: string | undefined,
): typeof ADO | typeof GitHub | '' =>
	repository?.trim()
		? isADORepositoryFormat(repository)
			? ADO
			: GitHub
		: '';
